import React from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { reduxForm, Field, reset } from "redux-form";
import { NotificationManager } from "react-notifications";
import moment from "moment";

import { FormField } from "../../../sharedComponents/formField";
import FilterPanel, { PanelBody, PanelFooter } from "../../../sharedComponents/filterPanel";
import { required } from "../../../constants/formValidators";
import { resetField, logExercise, editExercise, logExerciseAll } from "../../../store/actions";

const AddLogPanel = ({
	showAddLogPanel,
	resetField,
	handleSubmit,
	exercise,
	logExercise,
	editExercise,
	progressList,
	onUpdate = null,
	logExerciseAll,
	resetForm
}) => {
	const resetReducerField = () => {
		resetForm("AddLogForm");
		resetField("Exercises.toggleAddLogPanel", false);
		resetField("Exercises.exerciseToLog", null);
	};

	const validateForm = (events) => {
		const successHandler = (event) => {
			if (event.status >= 200 && event.status < 300) {
				NotificationManager.success("Successfully added!", "", 5000);
				const day = moment(events.datedone).format("dddd");
				progressList && progressList(day.toLowerCase());
				onUpdate && onUpdate();
				resetReducerField();
			} else {
				NotificationManager.error("Please try again!", "", 5000);
			}
		};

		if (exercise && exercise.id) {
			onUpdate
				? editExercise({ ...events, datedone: `${events.datedone} 00:00:00`, exercise: exercise.id }, successHandler)
				: logExercise({ ...events, datedone: `${events.datedone} 00:00:00`, exercise: exercise.id }, successHandler);
		} else {
			logExerciseAll(
				{
					...events,
					datedone: `${events.datedone} 00:00:00`,
					weekday: "monday",
					notes: events.notes ? events.notes : null
				},
				successHandler
			);
		}
	};

	return (
		<FilterPanel
			show={showAddLogPanel}
			toggle={resetReducerField}
			title={exercise ? exercise.name : "I did all of the exercises"}
			className="hide-sub-header"
			closeBtn>
			<form className="h-100 d-flex flex-column flex-fill" onSubmit={handleSubmit(validateForm)}>
				<PanelBody>
					<h4 className="text-primary-dark">Fill in the Date and Duration for this exercise</h4>
					<p>Feel free to leave yourself a note, if you like.</p>
					<div className="row">
						<Field
							label="Date Done"
							name="datedone"
							type="datepicker"
							validate={[required]}
							formGroupClass="col-6"
							component={FormField}
							propsDatePicker={{
								dateFormat: "yyyy-MM-dd",
								maxDate: new Date()
							}}
						/>
						{exercise && exercise.id ? (
							<Field
								label="Number of Minutes"
								name="duration"
								type="number"
								validate={[required]}
								formGroupClass="col-6"
								component={FormField}
								min="0"
							/>
						) : null}
					</div>
					<div className="row">
						<Field
							label="Notes (optional)"
							name="notes"
							type="textarea"
							formGroupClass="col-12"
							component={FormField}
						/>
					</div>
				</PanelBody>
				<PanelFooter className="sticky-footer text-right">
					<button type="button" className="btn btn-default" onClick={resetReducerField}>
						Cancel
					</button>
					<button type="submit" className="btn btn-primary-dark">
						Save
					</button>
				</PanelFooter>
			</form>
		</FilterPanel>
	);
};

const mapStateToProps = (state) => {
	const { Exercises } = state;
	return {
		showAddLogPanel: get(Exercises, "toggleAddLogPanel", false),
		exercise: get(Exercises, "exerciseToLog", null)
	};
};

const mapDispatchToProps = {
	resetField,
	logExercise,
	resetForm: reset,
	editExercise,
	logExerciseAll
};

export default reduxForm({
	form: "AddLogForm",
	enableReinitialize: true
})(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(AddLogPanel)
);
